<div class="app-content content content-dssawere">
    <div class="content-overlay"></div>
    <div class="content-wrapper p-0">
        <div class="content-body">
            <section class="row flexbox-container">
                <div class="col-12 d-flex align-items-center justify-content-center">
                    <div class="col-xxxxl-4 col-xxl-5 col-xl-6 col-md-8 col-10 box-shadow-2 p-0">
                        <div class="card px-1 py-1 m-0">
                            <div class="card-header d-block pb-0">
                                <div class="card-title text-center d-block">
                                    <img src="assets/images/logo/logo-dark.png" alt="branding logo">
                                </div>
                                <h6 class="card-subtitle line-on-side text-center fw-normal pt-2">
                                    <span>{{ 'login.forgotpassword.subtitle' | translate }}</span>
                                </h6>
                            </div>
                            <div class="card-content">
                                <app-alert></app-alert>
                                <div class="card-body pb-2">
                                    <form class="form-horizontal" [formGroup]="recoverPwdForm" (ngSubmit)="tryRecover()">
                                        <fieldset class="form-group input-group">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text input-group-icon"><i class="la la-envelope"></i></span>
                                            </div>
                                            <input type="text" formControlName="email" class="form-control"
                                                [ngClass]="{ 'is-invalid': submitted && f.email.errors }" id="user-name"
                                                placeholder="{{ 'login.forgotpassword.emailPlaceholder' | translate }}" required>
                                            <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                                                <div *ngIf="f.email.errors.required">{{ 'validations.emailRequired' | translate }}</div>
                                            </div>
                                        </fieldset>
                                        <p class="card-subtitle fw-normal mb-2">
                                            <span>{{ 'login.forgotpassword.instructions' | translate }}</span>
                                        </p>
                                        <fieldset class="form-group">
                                            <button type="submit" class="btn btn-success btn-block" [disabled]="loading">
                                                <i class="fa fa-refresh fa-spin" *ngIf="loading"></i>
                                                <i class="feather ft-unlock" *ngIf="!loading"></i> {{ 'login.forgotpassword.recoverButton' | translate }}
                                            </button>
                                        </fieldset>
                                        <div class="form-group row my-1">
                                            <div class="col-md-6 col-12 text-center text-sm-left pr-0">
                                               
                                            </div>
                                            <div class="col-md-6 col-12 float-sm-left text-center text-sm-right"><a
                                                [routerLink]="['/login']" class="card-link primary fw-bold">{{ 'login.forgotpassword.goToLogin' | translate }}</a>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </div>
    </div>
</div>